module.exports = __webpack_public_path__ + "static/media/giffTitan_en.faa709a7.webm";